import React from "react";
import { TextField, TextArea, SignatureField } from "../../common/FormFields";
import SignatureBox from "../AuditTrail/components/SignatureBox";
import PasswordField from "../AuditTrail/components/PasswordField";

/***
 * Using in following components:
 * 1. UserDisablePopup
 * 2. DisableUser
 */

const UserDisablePopupBody = ({
  disableUserData,
  setDisableUserData,
  showPassword,
  showSignature,
  sigPadRef,
  handleDisableSignatureEnd,
  viewPurpose=false
}) => {
  return (
    <>
      <div className="disable-modal-form-group">
        <TextArea
          label={<>Comments</>}
          placeholder="Enter comments..."
          value={disableUserData.changeRequestComments}
          onChange={(e) =>
            setDisableUserData((prev) => ({
              ...prev,
              changeRequestComments: e.target.value,
            }))
          }
          labelStyle={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
          readOnly={viewPurpose}
        />
      </div>

      <div className="disable-modal-form-group">
        <div className="disable-modal-disabled-by">
          <label className="disable-modal-disabled-by-label">
            Disabled By:
          </label>
          <span className="disable-modal-disabled-by-text">
            {disableUserData.disabledBy}
          </span>
        </div>
      </div>

      {/* Password - Only show if showPassword is true */}
      {showPassword && (
        <div className="disable-modal-form-group">
          {
            !viewPurpose ? <TextField
            label={
              <>
                Enter Password<span className="required">*</span>
              </>
            }
            type="password"
            placeholder="Enter your password"
            value={disableUserData.password}
            onChange={(e) =>
              setDisableUserData((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }
            labelStyle={{ fontSize: "14px", fontWeight: "bold" }}
          /> : <>
            <PasswordField password_bullets={disableUserData.password_bullets}/>
          </>
          }
        </div>
      )}

      {/* Signature - Only show if showSignature is true */}
      {showSignature && (
        <div className="disable-modal-form-group">
          {
            !viewPurpose ? <SignatureField
            ref={sigPadRef}
            label={
              <>
                Sign Here<span className="required">*</span>
              </>
            }
            width="100%"
            height="100px"
            onEnd={handleDisableSignatureEnd}
            labelStyle={{ fontSize: "14px", fontWeight: "bold" }}
            
          /> : <>
            <label style={{ marginTop: "20px" }}>Sign Here<span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span></label>
            <SignatureBox/>
          </>
          }
        </div>
      )}
    </>
  );
};

export default UserDisablePopupBody;